import React, {Component}  from 'react';
import axios from 'axios';
import {env} from './env';
import ReactDOM from 'react-dom';
// import TokenImpl from './TokenImpl'
// const BASE_URL = 'http://192.168.1.117:9090/';
// const BASE_URL = 'http://cibd-qa:8090/';
export const _HttpServices = {
    postData,
    getData,
    putData,
    deleteData
}



const tokenSetup = () => {
    const loggedInUserData = JSON.parse(localStorage.getItem('userData') );
    if (loggedInUserData) {
        if(loggedInUserData.Token){
            axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
            axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;    
    }
}
}


function postData(url, payLoad) {
    tokenSetup()
    return axios.post(`${env.baseUrl}${url}`, payLoad);
}

function getData(url) {
    tokenSetup()
    return axios.get(`${env.baseUrl}${url}`);
}

function putData(url, payLoad) {
    tokenSetup()
    return axios.put(`${env.baseUrl}${url}`, payLoad);
}

function deleteData(url) {
    tokenSetup()
    return axios.delete(`${env.baseUrl}${url}`);
}
